import { motion } from "framer-motion";
import { Check, Star, ArrowRight } from "lucide-react";

const tiers = [
  {
    id: "perus",
    name: "Perus",
    price: "150 €",
    monthly: "+ 30 €/kk",
    tagline: "Aloita vahvasti verkossa.",
    features: [
      "Moderni yrityssivu",
      "Mobiilioptimointi",
      "Google-näkyvyys (SEO-perusteet)",
      "Yhteydenottolomake",
      "Ylläpito ja päivitykset",
    ],
  },
  {
    id: "kasvu",
    name: "Kasvu",
    price: "390 €",
    monthly: "+ 30 €/kk",
    tagline: "Tehokas kasvupaketti.",
    highlighted: true,
    badge: "Suosituin",
    features: [
      "Kaikki Perus-paketin edut",
      "Varaus- / tarjouspyyntölomake sähköpostiohjauksella",
      "Kuvagalleria",
      "Google Maps -integrointi",
      "Some-linkitykset",
    ],
  },
  {
    id: "pro",
    name: "Pro",
    price: "690 €",
    monthly: "+ 49 €/kk",
    tagline: "Täysi liiketoiminta-alusta.",
    features: [
      "Kaikki Kasvu-paketin edut",
      "Oma hallintapaneeli sisällön päivitykseen",
      "Monisivuinen rakenne",
      "Laajennettu SEO",
    ],
  },
];

export default function WebService() {
  return (
    <section className="md-section relative" id="palvelut" data-testid="web-service-section">
      <div className="md-container">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl mb-12 md:mb-16"
        >
          <span className="md-eyebrow">Palvelut & Hinnat</span>
          <h2 className="mt-5 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">
            Ammattimaiset verkkosivut <span className="text-[#00E5FF]">alk. 150 € + 30 €/kk</span>
          </h2>
          <p className="mt-5 text-white/70 leading-relaxed">
            Kolme selkeää pakettia. Kiinteä hinta, ei yllätyksiä – näet valmiit mallisivut ennen kuin maksat euroakaan.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-testid="pricing-grid">
          {tiers.map((t, i) => (
            <motion.div
              key={t.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className={`relative p-8 rounded-3xl border transition-all ${
                t.highlighted
                  ? "bg-gradient-to-b from-[#141821] to-[#0B0D10] border-[#0066FF] md-glow"
                  : "bg-[#14171B] border-[#262b32] hover:border-[#0066FF]/40"
              }`}
              data-testid={`pricing-card-${t.id}`}
            >
              {t.badge && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 inline-flex items-center gap-1 bg-[#0066FF] text-white text-xs font-semibold px-3 py-1 rounded-full">
                  <Star size={12} fill="white" /> {t.badge}
                </div>
              )}
              <div className="text-sm font-mono uppercase tracking-widest text-[#00E5FF]">{t.name}</div>
              <div className="mt-4 flex items-end gap-2">
                <div className="font-display text-4xl md:text-5xl font-bold text-white">{t.price}</div>
                <div className="text-white/60 text-sm pb-2">{t.monthly}</div>
              </div>
              <p className="mt-2 text-white/60">{t.tagline}</p>

              <ul className="mt-6 space-y-3">
                {t.features.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-sm text-white/80">
                    <Check size={16} className="text-[#00E5FF] mt-0.5 shrink-0" />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>

              <a
                href="#yhteys"
                className={`mt-8 inline-flex w-full items-center justify-center gap-2 ${
                  t.highlighted ? "md-btn-primary" : "md-btn-secondary"
                }`}
                data-testid={`pricing-cta-${t.id}`}
                data-track={`pricing-${t.id}`}
              >
                Pyydä ilmaiset mallisivut <ArrowRight size={16} />
              </a>
            </motion.div>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mt-10 text-center text-white/60"
          data-testid="pricing-guarantee"
        >
          Näet valmiit mallisivut yrityksellesi <span className="text-white font-medium">ennen kuin maksat euroakaan.</span>
        </motion.p>
        <p className="mt-3 text-center text-xs text-white/40" data-testid="pricing-vat-note">
          Kaikki hinnat + alv 25,5 %.
        </p>
      </div>
    </section>
  );
}
